// extracted by mini-css-extract-plugin
module.exports = {"row":"_927a99ad28--row--mD6PZ","name":"_927a99ad28--name--_hP38","marketing_price":"_927a99ad28--marketing_price--TDBoL"};